<app-expansion-panel
    [chevronColor]="color()"
    [isExpanded]="isGroupedSourceVisible() || isFieldInterventionSourceVisible()">
    <div
        class="flex grow text-base font-medium"
        header>
        <div [class]="`block text-${color()}`">
            @if (groupedSource()) {
                <fa-icon
                    size="lg"
                    [class]="`mr-1 text-${iconColor()}`"
                    [icon]="['fad', 'layer-group']" />

                {{ groupedSource()!.name }}
            } @else if (fieldInterventionSource()) {
                <fa-layers
                    class="text-gray-300"
                    size="lg">
                    <fa-icon
                        [class]="`text-${iconColor()}`"
                        [icon]="['far', 'clipboard']" />
                    <fa-icon
                        [class]="`absolute top-3 left-1 text-${iconColor()}`"
                        [icon]="['fas', 'magnifying-glass']"
                        [transform]="'shrink-6'" />
                </fa-layers>
                {{ 'fieldIntervention' | transloco }}
            }
        </div>
    </div>
    <div
        class="p-2"
        content>
        @if (groupedSource()) {
            <app-legend [style]="groupedSource()!.style" />
        } @else if (fieldInterventionSource()) {
            <app-legend [style]="fieldInterventionSource()!.style" />
        }
    </div>
</app-expansion-panel>
